import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Vehicle initial values
export const vehicleInitialValues = {
  vehicleType: "",
  manufacturingYear: "",
  registrationNumber: "",
  owners: "",
  currentEstimateValue: "",
};

// Vehicle validation schema
export const vehicleValidationSchema = Yup.object().shape({
  name: Yup.string().required("Vehicle name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Purchase price is required")
    .positive("Must be a positive number > 0")
    .min(1, "Value must be 1 or greater"),
  vehicleType: Yup.string().required("Vehicle type is required"),
  manufacturingYear: Yup.string()
    // .required("Vehicle make and model are required")
    .matches(/^\d{4}$/, "Must be a valid 4-digit year")
    .test('year-range', 'Year must be between 1900 and current year + 1', function(value) {
      if (!value) return true;
      const year = parseInt(value);
      const currentYear = new Date().getFullYear();
      return year >= 1900 && year <= currentYear + 1;
    })
    .notRequired(),
  registrationNumber: Yup.string()
    // .required("Registration number is required")
    .min(3, "Min length: 3 characters")
    .max(20, "Max length: 20 characters"),
  // owners: Yup.string()
  //   .required("Owner(s) is required")
  //   .min(2, "Min length: 2 characters")
  //   .max(100, "Max length: 100 characters"),
  currentEstimateValue: Yup.number()
    .typeError("Must be a number")
    .positive("Must be a positive number > 0")
    .min(0.01, "Value must be greater than 0")
    .notRequired(),
});

/**
 * Vehicle Form - Field-only component for AddAssets.js
 * This renders only the vehicle-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const VehicleForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="vehicle"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default VehicleForm
